import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class ClaimService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	
	getClaim(claimId, onSuccess, onError) {
		this.httpClient.get(this.config.getRestUrl() + 'insurance/api/v1/claim/' + claimId, { withCredentials: true })
			.toPromise().then(onSuccess).catch(onError);
	}
	
	getPaymentMethodList(onSuccess, onError) {
		this.httpClient.get(this.config.getRestUrl() + 'insurance/api/v1/claim/payment/method/list', { withCredentials: true })
			.toPromise().then(onSuccess).catch(onError);
	}
	
}